import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class AemService {
  private contentSource = new BehaviorSubject<any>({});
  currentContent = this.contentSource.asObservable();
  setContent(content: any) {
    this.contentSource.next(content)
  }
}